import { Page } from '@touche-lts/panel-ui/dist'
import { ProductsFilterDTO, ProductsTableEntityDTO } from 'models'
import { FetchOptions } from 'services'
import { StatisticsTableSearchProps, StatisticsTableSortProps } from './statistics-table-base.types'
import { PaginationSearchBase } from '..'
import {
  initialStatisticsTablePaginationProps,
  initialStatisticsTableSearchProps,
  normalizeStatisticsListResponse,
  statisticsNeedTimeoutProps
} from './statistics-table-base.utils'
// import { RootStore } from 'mobx-stores'

export class StatisticsTableBase extends PaginationSearchBase<
  StatisticsTableSortProps,
  StatisticsTableSearchProps,
  ProductsTableEntityDTO
> {
 private rootStoreStats: any
  constructor (rootStore: any) {
    super({
      initialPaginationProps: initialStatisticsTablePaginationProps,
      initialSearchProps: initialStatisticsTableSearchProps,
      needTimeoutProps: statisticsNeedTimeoutProps
    })
    this.rootStoreStats = rootStore
  }

  public handleSearchResult = (data: unknown): void => {
    if (data == null) {
      this.setSearchResults([])
      this.setPaginationProps({
        page: 0,
        size: this.pagination.size,
        totalElements: 0,
        totalPages: 0
      } as any)
      return
    }
    const { items, pageMeta } = normalizeStatisticsListResponse<ProductsTableEntityDTO>(data)
    if (pageMeta && pageMeta.totalElements != null) {
      this.handleSearchResultPaginationProps(pageMeta as Page<ProductsTableEntityDTO>)
    } else {
      const total = items.length
      const size = this.pagination.size || 10
      this.setPaginationProps({
        page: 0,
        size,
        totalElements: total,
        totalPages: total > 0 ? Math.max(1, Math.ceil(total / size)) : 0
      } as any)
    }
    this.setSearchResults(items)
  }

  public getPageQueryParams = (
    resetPageNumber: boolean
  ): FetchOptions['pageQueryParams'] => {
    return {
      page: resetPageNumber ? 0 : this.pagination.page,
      size: this.pagination.size,
      sortDirection: this.pagination.sortDirection,
      sortProp: this.pagination.sortProp
    }
  }

  public get productFilter (): Partial<ProductsFilterDTO> {
    return {
        activeSkusMax: this.searchProps.activeSkusMax,
        activeSkusMin: this.searchProps.activeSkusMin,
        dateEnd: this.rootStoreStats.statisticsStore.endPeriod,
        dateStart: this.rootStoreStats.statisticsStore.periodDate,
        productName: this.searchProps.productName,
        revenueTotalMax: this.searchProps.maxRevenue,
        revenueTotalMin: this.searchProps.minRevenue,
        soldMax: this.searchProps.soldMax,
        soldMin: this.searchProps.soldMin,
        stockMax: this.searchProps.stockMax,
        stockMin: this.searchProps.stockMin
    }
  }

  public get storeFilter (): Partial<ProductsFilterDTO> {
    return {
        activeSkusMax: this.searchProps.activeSkusMax,
        activeSkusMin: this.searchProps.activeSkusMin,
        dateEnd: this.rootStoreStats.statisticsStore.endPeriod,
        dateStart: this.rootStoreStats.statisticsStore.periodDate,
        storeName: !!this.searchProps.storeName ? this.searchProps.storeName : undefined,
        productCountMax: this.searchProps.productCountMax,
        productCountMin: this.searchProps.productCountMin,
        revenueTotalMax: this.searchProps.maxRevenue,
        revenueTotalMin: this.searchProps.minRevenue,
        soldMax: this.searchProps.soldMax,
        soldMin: this.searchProps.soldMin,
        stockMax: this.searchProps.stockMax,
        stockMin: this.searchProps.stockMin
    }
  }
}
